import React from 'react';
import { IndexLink, Link } from "react-router";


class Logo extends React.Component{


  render(){


   return (
       <div className="logo-div">
        <a  href="/">
        <img className="logo-image" src="https://d2hfzg3ugxeze1.cloudfront.net/logo/GreenPlayologo%403x.png" alt="playo"/>
        </a>
      </div>
   )}

}


export default Logo;



// WEBPACK FOOTER //
// ./src/components/Navbar/logo.js